import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import * as actions from '../actions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_QUESTION_GROUP_STEP = 'requestQuestionGroupStep';
const REQUEST_QUESTION_GROUP_STEP_BY_CLAIM_APPLICATION =
    'requestQuestionGroupStepByClaimApplication';

export function requestQuestionGroupStep(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => {
            const policyTypeCode = action.payload.policyTypeCode
                ? action.payload.policyTypeCode
                : '___';
            const claimCategoryCode = action.payload.claimCategoryCode
                ? action.payload.claimCategoryCode
                : '___';
            const formTypeCode = action.payload.formTypeCode
                ? action.payload.formTypeCode
                : '___';
            return {
                url: `${GENERAL_FUNCTIONS.getBaseURL()}api/QuestionGroupStep/PolicyTypeCode/${policyTypeCode}/ClaimCategoryCode/${claimCategoryCode}/FormTypeCode/${formTypeCode}`,
                headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
                category: REQUEST_QUESTION_GROUP_STEP,
                method: 'GET',
            };
        });

    let httpResponse$ = sources.HTTP.select(REQUEST_QUESTION_GROUP_STEP)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeSuccess(
                      response,
                  )
                : actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeFailed(
                      response,
                  ),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestQuestionGroupStepByClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_QUESTION_GROUP_STEP_BY_POLICY_TYPE_AND_CLAIM_CATEGORY_AND_CLAIM_TYPE_BY_CLAIM_APPLICATION,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => {
            const policyTypeCode = action.payload.policyTypeCode
                ? action.payload.policyTypeCode
                : '___';
            const claimCategoryCode = action.payload.claimCategoryCode
                ? action.payload.claimCategoryCode
                : '___';
            const formTypeCode = action.payload.formTypeCode
                ? action.payload.formTypeCode
                : '___';
            const claimApplicationId = action.payload.claimApplicationId;
            return {
                url: `${GENERAL_FUNCTIONS.getBaseURL()}api/QuestionGroupStep/ClaimApplication/${claimApplicationId}/PolicyTypeCode/${policyTypeCode}/ClaimCategoryCode/${claimCategoryCode}/FormTypeCode/${formTypeCode}`,
                headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
                category: REQUEST_QUESTION_GROUP_STEP_BY_CLAIM_APPLICATION,
                method: 'GET',
            };
        });

    let httpResponse$ = sources.HTTP.select(
        REQUEST_QUESTION_GROUP_STEP_BY_CLAIM_APPLICATION,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationSuccess(
                      response,
                  )
                : actions.fetchQuestionGroupStepByPolicyTypeAndClaimCategoryAndClaimTypeByClaimApplicationFailed(
                      response,
                  ),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
